import { registerFormInputComponent } from '@vendure/admin-ui/core';

import { HiddenInputFormComponent } from './components/hidden-input/hidden-input.component';

export default [registerFormInputComponent('hidden-form-input', HiddenInputFormComponent)];
